import React, {Component} from 'react';
import SideBar from './sidebar/SideBar';
import Footer from './components/Footer';
import Nav from './Header/Nav';
import javascript from '../assets/images/javascript.jpg';
import jssvg from '../assets/images/js.svg';
import training5 from '../assets/images/training5.jpg';
import DevelopRequest from './components/DevelopRequest';
import Subscribe from './components/Subscribe';

class FrontendBundle extends Component{
    render(){
        return(
            <div id="App">
            <SideBar />
                <Nav />
            <header class="showcase" style={{height:'80vh', marginTop:'5vh', backgroundImage: `url(${training5})`}}>
			<div className="showcase-content">
                <div></div>
                <div>
				<h1>Be in <span style={{color:'rgba(226, 155, 24, 0.945)'}}> Demand.</span></h1>
                <p>"Oh wow. Oh wow. Oh wow."</p>
                <p>
                &mdash; Steve Jobs.
                </p>
                </div>
			</div>
		</header>
        <div className="about">
            <div style={{backgroundImage: `url(${javascript})`, backgroundClip:'border-box', backgroundPosition:'center', backgroundSize:'cover'}}></div>

            <div>
            <h3 className="path">Frontend Web Developer Bundle</h3>
            <img src={jssvg} alt="frontend web development training in abuja" />
            <p> 
                If you've ever wondered how a website is laid out, how the buttons respond to interactions, and how simple or complicated it looks and feels.
                All these site features are the work of front-end development. People who specialize in this type of design are called Front-end Web Developers.
            </p>
            <p> 
            If you're looking to begin your programming journey, front-end development is a great and versatile way to get you there.
            </p>

            <h3>courses</h3>
            <p>
                HTML5, CSS3, Bootstrap 4, JavaScript, ES6.
            </p>

            <h3>call anytime</h3>
            <p>07063509602, 07084894979</p>
            <p>info@codeflarelimited.com</p>

            <h3>visit us</h3>
            <p>Suite C3-19 Central Market Plaza, Beside Sledge Resort, Off Byazhin Roundabout, Kubwa, Abuja.</p>
            </div>
        </div>
        <DevelopRequest />
        <Subscribe />
        <Footer />
            </div>
        )
    }
}

export default FrontendBundle;